import { render, staticRenderFns } from "./OBCamp.vue?vue&type=template&id=5951c1a7&scoped=true"
import script from "./OBCamp.vue?vue&type=script&lang=js"
export * from "./OBCamp.vue?vue&type=script&lang=js"
import style0 from "./OBCamp.vue?vue&type=style&index=0&id=5951c1a7&prod&lang=scss"
import style1 from "./OBCamp.vue?vue&type=style&index=1&id=5951c1a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5951c1a7",
  null
  
)

export default component.exports